export default __webpack_public_path__ + "static/media/gallery_02.d649f899.jpg";